export function findTileByID(element) {
  return element.fID === this.fRemovingTileID;
}
